import React from 'react';
import classNames from 'classnames';
import { PersonaInfo, PersonaLabel } from '~/interfaces';
import PersonaContext from './context/persona';
import { isMobileUA } from '~/utils';

interface PersonaCollectProps {
    className?: string;
    title: string;
    subTitle: string;
    personaInfo?: PersonaInfo;
    personaLabel?: PersonaLabel;
    setPersonaInfo: (action: (prevState: PersonaInfo) => PersonaInfo) => void;
    children?: React.ReactNode;
}

const PersonaCollect: React.FC<PersonaCollectProps> = (props) => {
    const { className, title, subTitle, personaInfo, personaLabel, setPersonaInfo, children } =
        props;

    return (
        <PersonaContext.Provider
            value={{
                personaInfo,
                setPersonaInfo: (val: PersonaInfo) => {
                    setPersonaInfo((prev) => {
                        return { ...prev, ...val };
                    });
                },
                personaLabel
            }}
        >
            <div
                className={classNames('fx-persona-collect', className, {
                    'is-mobile': isMobileUA()
                })}
            >
                <div className="title">{title}</div>
                <div className="sub-title">{subTitle}</div>
                {children}
            </div>
        </PersonaContext.Provider>
    );
};

export default PersonaCollect;
